import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  ordersSimple: {
    width: 100,
    height: 100,
    d: `M81.07,9.52H18.93a4.89,4.89,0,0,0-4.88,4.89V85.59a4.89,4.89,0,0,0,4.88,4.89H81.07A4.89,
    4.89,0,0,0,86,85.59V14.41A4.89,4.89,0,0,0,81.07,9.52ZM29.83,76.81a5.61,5.61,0,1,1,5.61-5.6A5.6,
    5.6,0,0,1,29.83,76.81Zm0-20.92a5.61,5.61,0,1,1,5.61-5.6A5.6,5.6,0,0,1,29.83,55.89Zm0-20.92a5.61,
    5.61,0,1,1,5.61-5.61A5.61,5.61,0,0,1,29.83,35ZM75.2,74.1a2.11,2.11,0,0,1-2.11,2.11H42.23a2.12,2.12,
    0,0,1-2.11-2.11V68.32a2.11,2.11,0,0,1,2.11-2.11H73.09a2.1,2.1,0,0,1,2.11,2.11Zm0-20.92a2.11,2.11,0,0,
    1-2.11,2.11H42.23a2.12,2.12,0,0,1-2.11-2.11V47.39a2.11,2.11,0,0,1,2.11-2.1H73.09a2.1,2.1,0,0,1,2.11,
    2.1Zm0-20.93a2.1,2.1,0,0,1-2.11,2.11H42.23a2.11,2.11,0,0,1-2.11-2.11V26.47a2.12,2.12,0,0,1,
    2.11-2.11H73.09a2.11,2.11,0,0,1,2.11,2.11Z`,
  },
});
